import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { RequestProviderResponse } from "@/types";

export type UpdateProviderRequestDTO = {
  id: string;
  name: string;
  phone: string;
  cnpj: string;
  cpf: string;
  address: string;
  comments: string;
  name_of_person_responsible: string;
  phone_person_responsible: string;
};

async function updateProvider(
  request: UpdateProviderRequestDTO
): Promise<RequestProviderResponse> {
  const { id, ...updateData } = request;

  const response = await httpRequest.put<RequestProviderResponse>(
    `/providers/${id}`,
    updateData
  );
  return response.data;
}

export function useUpdateProviderMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateProvider,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
}
